<script>
import { Navigate } from 'svelte-router-spa';


let active = false;

function changeActive() {
	active = !active;
}

function closeActive() {
	active = false;
}

</script>



<style>

#navbar {

}

</style>



<nav class="navbar is-fixed-top" id="navbar">

	<div class="container">


		<div class="navbar-brand">

			<Navigate to="/" styles="navbar-item" on:click={closeActive}>
				<img src="/img/logo.png" style="width: 37px !important;">
					<span>AHG Forms</span>
			</Navigate>

			<a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbar-items" on:click={changeActive} class:is-active={active}>
				<span aria-hidden="true"></span>
				<span aria-hidden="true"></span>
				<span aria-hidden="true"></span>
			</a>

		</div>


		<div class="navbar-menu" id="navbar-items" class:is-active={active}>


			<div class="navbar-start">

				<Navigate styles="navbar-item" to="/forms" on:click={closeActive}>
					<span>Forms</span>
				</Navigate>

				<!-- <Navigate styles="navbar-item" to="/forms/submitted" on:click={closeActive}>
					<span>Submitted Forms</span>
				</Navigate> -->

				<!-- <Navigate styles="navbar-item" to="/forms" on:click={closeActive}>
					<span>Forms</span>
				</Navigate> -->

			</div>


			<div class="navbar-end">

				<!-- <Navigate styles="navbar-item" to="/forms" on:click={closeActive}>
					<span>Forms</span>
				</Navigate> -->

				<Navigate styles="navbar-item" to="/contact" on:click={closeActive}>
					<span>Contact</span>
				</Navigate>

			</div>


		</div>


	</div>

</nav>


